import React, { useState, useEffect } from 'react';
import '../../../App.css';
import Select, { components } from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { 
  bookingService, 
  companyService, 
  locationService, 
  talentService 
} from '../../../api/apiService';

function NewBookingCreationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  
  const dateFromURL = new URLSearchParams(location.search).get('date'); // "29.08.23"
  const formattedDate = dateFromURL ? moment(dateFromURL, "DD.MM.YY").format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"); // converts "29.08.23" to "2023-08-29"
  
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState(formattedDate);
  const [status, setStatus] = useState('');
  const [bookingDetails, setBookingDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState(new URLSearchParams(location.search).get('sonstige') || '');
  const [kpi, setKpi] = useState(new URLSearchParams(location.search).get('artikelanzahl') || '');
  const [setOption, setSetOption] = useState(null);
  const [segment, setSegment] = useState(new URLSearchParams(location.search).get('segment') || '');
  const [range, setRange] = useState(new URLSearchParams(location.search).get('range') || '');
  
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [sinfo, setSinfo] = useState('');

  const companyNameurl = new URLSearchParams(location.search).get('kunde');
  const [bookingOption, setBookingOption] = useState(null);
  const [selectedBilling, setSelectedBilling] = useState({ value: 'daily', label: 'Day Rate (per day)' });
  
  const initialClient = new URLSearchParams(location.search).get('kunde');
  const [client, setClient] = useState(null);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);

  const statusOptions = [
    { value: 'new order', label: 'New order' },
    { value: 'optioned', label: 'Optioned' },
    { value: 'talentaccepted', label: 'Accepted by talent' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'lano', label: 'Lano' }
  ];
  
  const positionOptions = [
    { value: 'Hair & Make-Up', label: 'Hair & Make-Up' },
    { value: 'Art Direktion', label: 'Art Direktion' },
    { value: 'Foto', label: 'Foto' },
    { value: 'Foto Assist', label: 'Foto Assist' },
    { value: 'Video', label: 'Video' },
    { value: 'Digi-OP', label: 'Digi-OP' },
    { value: 'Styling', label: 'Styling' },
    { value: 'Styling Assist', label: 'Styling Assist' },
    { value: "LOGISTIK / WARENAUFBEREITUNG", label: "LOGISTIK / WARENAUFBEREITUNG" },
    { value: "PRODUCER", label: "PRODUCER" },
    { value: "Art Buying", label: "Art Buying" }, 
    { value: "Account Management", label: "Account Management" },
    { value: "AI Content Production", label: "AI Content Production" },
    { value: 'Development', label: 'Development' },
    { value: 'Post Production', label: 'Post Production' },
    { value: '3D Artist', label: '3D Artist' },
    { value: 'Marketing I Sales 70440', label: 'Marketing I Sales 70440' },
  ];
  
  const setOptions = [
    { value: 'On Model', label: 'On Model' },
    { value: 'On Produkt', label: 'On Produkt' },
    { value: 'digital Production', label: 'digital Production' }
  ];

  const bookingOptions = [
    { value: 'booking', label: 'Booking' },
    { value: 'option', label: 'Option' }
  ];

  const billingOptions = [
    { value: 'daily', label: 'Day Rate (per day)' },
    { value: 'hourly', label: 'Hourly Rate (per hour)' }
  ];

  const bookingId = new URLSearchParams(location.search).get('bookingId');

  const customStyles = {
    dropdownIndicator: (provided) => ({
      ...provided,
      border: 'none',
    }),
    control: (base) => ({
      ...base,
      width: '100%',
      borderColor: 'black',
      borderWidth: '1px',
      boxShadow: 'none',
      margin: '0 0 10px 0',
      borderRadius: '0px',
      color: 'black',
      fontWeight: "700",
      height: '50px',
      textTransform: 'uppercase',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
      fontWeight: "700"
    }),
    input: (provided) => ({
      ...provided,
      color: 'black',
      fontWeight: "700"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'black' : 'inherit',
      '&:hover': { backgroundColor: state.isSelected ? 'black' : '#f7f7f7' }
    }),
  };

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: '16px', margin: '0' }}>
            <svg version="1.1" id="Isolationsmodus" x="0px" y="0px" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
              <path xmlns="http://www.w3.org/2000/svg" d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };

  const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
  const [selectedPosition, setSelectedPosition] = useState(null);
  
  // Validation states
  const [clientValid, setClientValid] = useState(true);
  const [positionValid, setPositionValid] = useState(true);
  const [optionsValid, setOptionsValid] = useState(true);
  const [timesValid, setTimesValid] = useState(true);

  useEffect(() => {
    // Fetch companies, locations, and talents when component mounts
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch companies
        const companiesResponse = await companyService.getAllCompanies(1, 1000);
        const companiesData = companiesResponse.data?.companies || [];
        
        const formattedCompanies = companiesData.map(company => ({
          value: company.id,
          label: company.name
        })).sort((a, b) => a.label.localeCompare(b.label));
        
        setCompanyOptions(formattedCompanies);
        setCompanies(formattedCompanies);
        
        // Set initial company if provided in URL
        if (companyNameurl) {
          const matchingCompany = formattedCompanies.find(
            company => company.label === companyNameurl
          );
          if (matchingCompany) {
            setClient(matchingCompany);
          }
        }
        
        // Fetch locations
        const locationsResponse = await locationService.getAllLocations(1, 1000);
        const locationsData = locationsResponse.data?.locations || [];
        
        const formattedLocations = locationsData
          .filter(location => location.short !== 'OSB')
          .map(location => ({
            value: location.id,
            label: location.name || location.short,
            locationData: location // Store the full location object for saving
          })).sort((a, b) => a.label.localeCompare(b.label));
        
        setLocationOptions(formattedLocations);
        
        // Fetch talents (if needed)
        const talentsResponse = await talentService.getAllTalents(1, 1000);
        const talentsData = talentsResponse.data?.talents || [];
        
        const formattedTalents = talentsData.map(talent => ({
          value: talent.id,
          label: talent.name,
          email: talent.email
        }));
        
        setTalents(formattedTalents);
        
        // If bookingId exists, fetch booking details
        if (bookingId) {
          const bookingResponse = await bookingService.getBookingById(bookingId);
          const bookingData = bookingResponse.data;
          
          if (bookingData) {
            setBookingDetails(bookingData);
            
            // Pre-fill form with booking data
            setTitle(bookingData.title || '');
            setStartDate(moment(bookingData.start_date).format('YYYY-MM-DD'));
            setEndDate(moment(bookingData.end_date).format('YYYY-MM-DD'));
            setStartTime(bookingData.start_time || '');
            setEndTime(bookingData.end_time || '');
            setSinfo(bookingData.sonstige_info || '');
            setDescription(bookingData.studio || '');
            setKpi(bookingData.kpi || '');
            
            // Set select options
            const status = statusOptions.find(opt => opt.value === bookingData.status);
            if (status) setSelectedStatus(status);
            
            const position = positionOptions.find(
              opt => opt.value === (bookingData.position?.value || bookingData.position)
            );
            if (position) setSelectedPosition(position);
            
            const setOpt = setOptions.find(
              opt => opt.value === (bookingData.set?.value || bookingData.set)
            );
            if (setOpt) setSetOption(setOpt);
            
            const bookingOpt = bookingOptions.find(
              opt => opt.value === (bookingData.option?.value || bookingData.option)
            );
            if (bookingOpt) setBookingOption(bookingOpt);

            const billingOpt = billingOptions.find(
              opt => opt.value === bookingData.billing_type
            );
            if (billingOpt) setSelectedBilling(billingOpt);
            
            // Find client
            if (bookingData.client) {
              const clientOpt = formattedCompanies.find(
                opt => opt.value === bookingData.client.id || 
                      opt.label === bookingData.client.label || 
                      opt.label === bookingData.client
              );
              if (clientOpt) setClient(clientOpt);
            }
            
            // Find location
            if (bookingData.location) {
              const locationOpt = formattedLocations.find(
                opt => opt.value === bookingData.location.id || 
                      opt.label === bookingData.location.label || 
                      opt.label === bookingData.location ||
                      opt.value === bookingData.location // Handle case where location is just an ID
              );
              if (locationOpt) setSelectedLocation(locationOpt);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [bookingId, companyNameurl]);

  // Handler functions for select components
  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  const handleSetSelect = (selectedOption) => {
    setSetOption(selectedOption);
  };

  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
  };

  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption);
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
  };

  const handlePositionChange = (selectedOption) => {
    setSelectedPosition(selectedOption);
  };

  const handleClientChange = (selectedOption) => {
    setClient(selectedOption);
  };

  const handleBookingOptionChange = (selectedOption) => {
    setBookingOption(selectedOption);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!client) {
      setClientValid(false);
      return;
    } else {
      setClientValid(true);
    }
  
    if (!selectedPosition) {
      setPositionValid(false);
      return;
    } else {
      setPositionValid(true);
    }

    if (!bookingOption) {
      setOptionsValid(false);
      return;
    } else {
      setOptionsValid(true);
    }

    // Hourly bookings bill Stundensatz × hours, so valid times are mandatory
    const isHourly = selectedBilling?.value === 'hourly';
    const timePattern = /^\d{1,2}:\d{2}$/;
    if (isHourly && (!timePattern.test((startTime || '').trim()) || !timePattern.test((endTime || '').trim()))) {
      setTimesValid(false);
      return;
    } else {
      setTimesValid(true);
    }

    // Check if it's an update or a new booking
    try {
      // Prepare booking data
      const bookingData = {
        title: title || `${client?.label || 'New Booking'} - ${selectedPosition?.label || 'Untitled'}`,
        start_date: startDate,
        end_date: endDate || startDate,
        start_time: startTime,
        end_time: endTime,
        // Always set status to 'new order' when creating a new booking, use selectedStatus only for updates
        status: bookingId ? (selectedStatus?.value || 'new order') : 'new order',
        kpi: kpi || 0,
        set: setOption?.value || '',
        position: selectedPosition,
        client: client,
        option: bookingOption?.value || '',
        billing_type: selectedBilling?.value || 'daily',
        location: selectedLocation?.locationData || selectedLocation?.value || null,
        studio: description || '',
        sonstige_info: sinfo || '',
        proposed_by: localStorage.getItem("userEmail") || '',
        created_by: localStorage.getItem("userEmail") || ''
      };

      if (bookingId) {
        // Update existing booking
        await bookingService.updateBooking(bookingId, bookingData);
        // Reload page instead of showing alert
        window.location.reload();
      } else {
        // Create new booking for each day in the date range
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate || startDate);
        
        for (let date = new Date(startDateObj); date <= endDateObj; date.setDate(date.getDate() + 1)) {
          const singleDayData = {
            ...bookingData,
            start_date: moment(date).format('YYYY-MM-DD'),
            end_date: moment(date).format('YYYY-MM-DD')
          };
          
          await bookingService.createBooking(singleDayData);
        }
        
        // Send notification email if needed
        if (selectedTalent?.email) {
          const emailData = {
            to: [selectedTalent.email, 'booking@set-cast.com', localStorage.getItem("userEmail")].filter(Boolean).join(', '),
            subject: 'New Booking Created',
            text: `A new booking has been created: ${title}`,
            html: `
              <p>A new booking has been created.</p>
              <p>Title: ${title}</p>
              <p>Start Date: ${startDate}</p>
              <p>End Date: ${endDate || startDate}</p>
              <p>Position: ${selectedPosition?.label || ''}</p>
              <p>Client: ${client?.label || ''}</p>
              <p>KPI: ${kpi || ''}</p>
              <p>Set: ${setOption?.label || ''}</p>

              <p>We wish you a successful production.</p>
              <p>Warm regards,</p>
              <p>Talents Management Team</p>
              <p>talents@set-cast.com</p>

           <p>In case of illness or delay, please send an email directly to the distribution list planning@orendtstudios.com and krank@set-cast.com by 8:00 a.m. at the latest.</p>
          <p>Please make sure to inform Set-Cast and the producer of the production if you need to leave the set early and double check with the producer if the KPI has been reached.</p>
          <p>For questions regarding KPI, shooting schedules, callsheets and briefings, please contact planning@orendtstudios.com.</p>
          <p>Invoice details:</p>
          <p>please upload your invoice in Lano - you could combine several tasks in one invoice</p>
          <p>If you have any questions, please contact us at booking@set-cast.com</p>
          <p>Best regards,<br>The Set-Cast Team</p>
          <p>LEGENDE:</p>
          <p>B28 = Behringstrasse 28a, 22765 Hamburg</p>
          <p>TR4 = Tarpenring 4, 22419 Hamburg</p>
          <p>M= Holy-Allee 3, Metzingen , am Empfang melden</p>
          <p>OSB= Am Rosenkothen 2, 40880 Ratingen</p>
            <p>EB5 = Essener Bogen 5, 22419 Hamburg</p>


            `
          };
          
          try {
            await bookingService.sendEmail(emailData);
          } catch (error) {
            console.error('Error sending notification email:', error);
          }
        }
        
        // Reload page instead of showing alert and navigating
        window.location.reload();
      }
      
      // Navigate back to bookings list
      navigate('/admin/allbooking');
    } catch (error) {
      console.error('Error saving booking:', error);
      alert(`Error: ${error.message || 'Could not save booking. Please try again.'}`);
    }
  };

  // UI helper to display a date field with custom icon
  const DateField = ({ id, value, onChange, placeholder, required = false }) => (
    <div className="date-input-wrapper">
      <input 
        className='inputdate' 
        id={id} 
        type="date" 
        value={value} 
        onChange={(e) => onChange(e.target.value)} 
        required={required} 
        placeholder={placeholder} 
      />
      <svg className="custom-icon" viewBox="0 0 500 500">
        <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
      </svg>
    </div>
  );

  return (
    <div className="content-wrapper page">
      <section>
        <h1 className='h1'>{bookingId ? 'Update Booking' : 'Create Order'}</h1>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <form 
            onSubmit={handleSubmit}
            style={{
              marginTop: '40px',
              maxWidth: '500px'
            }}
          >
            <Select
              components={{ DropdownIndicator }}
              options={companyOptions}
              onChange={handleClientChange}
              placeholder="Client"
              value={client}
              styles={customStyles}
            />
            {!clientValid && <p className="error-message">Client is required.</p>}

            <Select
              components={{ DropdownIndicator }}
              options={positionOptions}
              onChange={handlePositionChange}
              placeholder="Position"
              value={selectedPosition}
              styles={customStyles}
            />
            {!positionValid && <p className="error-message">Position is required.</p>}
            
            <input 
              className='inputtext' 
              type="text" 
              value={description} 
              onChange={(e) => setDescription(e.target.value)} 
              placeholder='Studio'
            />

            <Select
              value={selectedLocation}
              onChange={handleLocationChange}
              options={locationOptions}
              isClearable
              placeholder="Location"
              styles={customStyles}
            />
            
            <input 
              className='inputtext' 
              type="text" 
              value={kpi} 
              onChange={(e) => setKpi(e.target.value)} 
              placeholder='KPI'
            />

            <Select
              components={{ DropdownIndicator }}
              options={setOptions}
              onChange={handleSetSelect}
              placeholder="Set"
              value={setOption}
              styles={customStyles}
            />
            
            <input 
              className='inputtext' 
              type="text" 
              value={sinfo} 
              onChange={(e) => setSinfo(e.target.value)}  
              placeholder='Additional Info'
            />

            <Select
              components={{ DropdownIndicator }}
              options={billingOptions}
              onChange={(selectedOption) => setSelectedBilling(selectedOption)}
              placeholder="Billing"
              value={selectedBilling}
              styles={customStyles}
            />

            <input
              className='inputtext'
              type="text"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              placeholder='Start Time (HH:MM)'
            />

            <input
              className='inputtext'
              type="text"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              placeholder='End Time (HH:MM)'
            />
            {!timesValid && <p className="error-message">Start and end time (HH:MM) are required for hourly bookings.</p>}

            <div style={{ display: 'flex' }}>
              <DateField 
                id="start-date" 
                value={startDate} 
                onChange={setStartDate} 
                placeholder="Start Date" 
                required={true}
              />

              <DateField 
                id="end-date" 
                value={endDate} 
                onChange={setEndDate} 
                placeholder="End Date" 
                required={true}
              />
            </div>

            {/* Only show status dropdown when editing an existing booking */}
            {bookingId && (
              <Select
                components={{ DropdownIndicator }}
                options={statusOptions}
                onChange={handleStatusChange}
                placeholder="Status"
                value={selectedStatus}
                styles={customStyles}
              />
            )}

            <Select
              components={{ DropdownIndicator }}
              options={bookingOptions}
              onChange={handleBookingOptionChange}
              placeholder="Option"
              value={bookingOption}
              styles={customStyles}
            />
            {!optionsValid && <p className="error-message">Option is required.</p>}

            <button 
              style={{ marginTop: '20px' }} 
              className='big-button' 
              type="submit"
            >
              {bookingId ? 'Update Booking' : 'Create Order'}
            </button>
          </form>
        )}
      </section>
    </div>
  );
}

export default NewBookingCreationPage;
